export const APP_ROUTER_PARAM = 'lwrt';
export const APP_MULTI_IFRAME_ROUTER_PARAM = 'mlwrtif';
export const APP_SOCIAL_TYPE_PARAM = 'ac_vh_s';
